import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { MainComponent as SeguridadMainComponent} from './../seguridad/main/main.component';
import { FormsModule } from '@angular/forms';
import { CuerpoComponent } from './cuerpo/cuerpo.component';
import { MenuComponent } from './layout/menu/menu.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { RoutesMap } from './routes.const';
import { MainComponent } from './main/main.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from './service/authentication.service';

const routes: Route[] = [
  {
    path: '',
    component: SeguridadMainComponent,
    loadChildren: './../seguridad/seguridad.module#SeguridadModule',
  },
  {
    path: RoutesMap.LISTA_CREDITO,
    component: LayoutComponent,
    loadChildren: './../credito/credito.module#CreditoModule',
  },
  {
    path: RoutesMap.DETALLE_CREDITO,
    component: LayoutComponent,
    loadChildren: './../creditodetalle/creditodetalle.module#CreditodetalleModule',
  },
  {
    path: RoutesMap.CRONOGRAMA,
    component: LayoutComponent,
    loadChildren: './../cronograma/cronograma.module#CronogramaModule',
  },
  /*INICIO: INE(EGB) 20220621 - REQ22111*/
  {
    path: RoutesMap.ACTUALIZAR_DATOS,
    component: LayoutComponent,
    loadChildren: './../actualizar/actualizar.module#ActualizarModule',
  },
  /*FIN: INE(EGB) 20220621 - REQ22111*/
  {
    path: RoutesMap.IMPUESTO_VEHICULAR,
    component: LayoutComponent,
    loadChildren: './../impuestovehicular/impuestovehicular.module#ImpuestovehicularModule',
  },
  {
    path: RoutesMap.ESTADO_CUENTA,
    component: LayoutComponent,
    loadChildren: './../estadocuenta/estadocuenta.module#EstadocuentaModule',
  },
  {
    path: RoutesMap.REQUERIMIENTOS,
    component: LayoutComponent,
    loadChildren: './../requerimientos/requerimientos.module#RequerimientosModule',
  },
  {
    path: RoutesMap.CONCESIONARIO,
    component: LayoutComponent,
    loadChildren: '../concesionario/concesionario.module#ConcesionarioModule',
  },
  {
    path: RoutesMap.ADMINISTRACION,
    component: LayoutComponent,
    //loadChildren: '../administracion/administracion.module#AdministracionModule', //: INE(JJGJ) 20221018 - REQ22978 - se coment�
    loadChildren: './../panel-admin/desbloqueousuarios/desbloqueousuarios.module#DesbloqueousuariosModule',//: ADD - INE(JJGJ) 20221018 - REQ22978
  },
  {
    path: RoutesMap.PREPAGO,
    component: LayoutComponent,
    loadChildren: '../prepago/prepago.module#PrepagoModule',
  },
  {
    path: RoutesMap.PREPAGOLISTA,
    component: LayoutComponent,
    loadChildren: '../prepagolista/prepagolista.module#PrepagoModule',
  },
   /*INI: INE(JJGJ) 20221018 - REQ22978 */
   {
    path: RoutesMap.CONFIG_PRUEBA_SERVICIOS,
    component: LayoutComponent,
    loadChildren: './../panel-admin/servicio-test/serviciostest.module#ServiciostestModule',
  },
  {
    path: RoutesMap.CONFIG_PARAMETROS,
    component: LayoutComponent,
    loadChildren: './../panel-admin/parametrosweb/parametrosweb.module#ParametroswebModule',
  },
  {
    path: RoutesMap.TRAMITES,
    component: LayoutComponent,
    loadChildren: './../seguimientotramites/seguimientotramites.module#SeguimientotramitesModule',
  },
  {
    path: RoutesMap.SEGUROS,
    component: LayoutComponent,
    loadChildren: './../seguros/seguros.module#SegurosModule',
  },
  {
    path: RoutesMap.DESBLOQUEO_USUARIO,
    component: LayoutComponent,
    loadChildren: './../panel-admin/desbloqueousuarios/desbloqueousuarios.module#DesbloqueousuariosModule',
  },
  /*FIN: INE(JJGJ) 20221018 - REQ22978 */
  // { path: '**', component: PageNotFoundComponent }
  /***INICIO - CSTI(EACN) 20231017 - REQ25710  ***/
  {
    path: RoutesMap.PREGUNTAS_FRECUENTES,
    component: LayoutComponent,
    loadChildren:
      "../preguntasfrecuentes/preguntasfrecuentes.module#PreguntasFrecuentesModule",
  },
  /***FIN - CSTI(EACN) 20231017 - REQ25710  ***/
  // INI INE(JJGJ) 20231010 REQ25710
  {
    path: RoutesMap.CREDITO_HEVICULAR,
    component: LayoutComponent,
    loadChildren:
      "../creditovehicular/creditovehicular.module#CreditoVehicularModule",
  },
  // FIN INE(JJGJ) 20231010 REQ25710
  /***INICIO - CSTI(EACN) 20231017 - REQ25710 ***/
  //INI COMMENT - EXP(CMOGOLLON) 20250220 REQ40119
  // {
  //   path: RoutesMap.PRESTAMO_PERSONAL,
  //   component: LayoutComponent,
  //   loadChildren:
  //     "../prestamopersonal/prestamopersonal.module#PrestamoPersonalModule",
  // },
  //FIN COMMENT - EXP(CMOGOLLON) 20250220 REQ40119
  /***INICIO - CSTI(EACN) 20231017 - REQ25710 ***/
  // INI INE(JJGJ) 20231010 REQ25710
  {
    path: RoutesMap.COMPROBANTES_PAGO,
    component: LayoutComponent,
    loadChildren:
      "../boletasfacturas/boletasfacturas.module#CreditoVehicularModule",
  },
  // FIN INE(JJGJ) 20231010 REQ25710
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    FormsModule,
    HttpClientModule
  ],
  exports: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    MenuComponent,
  ],
  declarations: [ LayoutComponent , CuerpoComponent,
                 MenuComponent, HeaderComponent, FooterComponent,
                 MainComponent],
  providers: [AuthenticationService, {provide: Window, useValue: window}],
})
export class CoreModule { }
